var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 5.92487 5.92487 1 12 1H28C34.0751 1 39 5.92487 39 12V28C39 34.0751 34.0751 39 28 39H12C5.92487 39 1 34.0751 1 28V12Z",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_284",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 10,
    width: 21,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.371 10.25H8.87061V29.7504H28.371V10.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7911 20.6074L13.2436 21.9461C13.957 22.2224 14.7532 22.1254 15.3863 21.6838L22.7428 16.5563C22.9093 16.44 23.1317 16.4627 23.2739 16.6113C23.4429 16.788 23.437 17.0757 23.2622 17.2453L17.8184 22.5127C17.5081 22.8127 17.5324 23.3338 17.8694 23.6005L23.6193 28.1641C24.6556 28.9869 26.156 28.3529 26.355 27.0081L28.3564 13.4984C28.4978 12.5462 27.5845 11.8021 26.7356 12.1772L9.77103 19.6814C9.59456 19.7592 9.47998 19.9402 9.47998 20.1405C9.47998 20.3486 9.60376 20.5348 9.7911 20.6074Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.de952485ac5841daa1022d90daeb353e.svg";
export { ForwardRef as ReactComponent };